'use client'
import * as React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import clsx from 'clsx'
import Button , {ButtonType} from 'components/button/Button'
import Logo from 'assets/icons/common/logo-1.svg'

import ChevronDownWhite from 'assets/icons/common/chevron-down-white.svg'
import ChevronDownBlack from 'assets/icons/common/chevron-down-black.svg'
import classes from './navbar.module.css'
import {navbarLinks} from 'content/navbar'
import {HYBRID_APP} from 'utils/getters'
interface NavbarProps {
  optionalLogo?: React.ReactDOM
  customLinkClassName?: string
  isDarkDownArrow?: boolean
  signInBtnVariant ?: ButtonType
  signInBtnCustomCss ?: React.CSSProperties
  customLineClassName ?: string
}

export default function Navbar({
  optionalLogo,
  customLinkClassName = '',
  isDarkDownArrow = false,
  signInBtnVariant = 'secondary',
  signInBtnCustomCss,
  customLineClassName = ''
}: NavbarProps) {
  const [isWebNavOpen, setWebNavOpen] = React.useState(false)
  const [isMobileNavOpen, setMobileNavOpen] = React.useState(false)

  return (
    <>
      <nav className={classes.navbar}>
        <div className={classes.logo}>
          <Link href="/">
            <Image
              src={optionalLogo || Logo}
              alt={'logo'}
              height={50}
              className={classes.companyLogo}
            />
          </Link>
        </div>
        <div className={classes.links}>
          {navbarLinks.map((link, index) =>
            link.dropdown ? (
              <div
                key={index}
                className={clsx(classes.link, classes.dropdownGroup, customLinkClassName)}
                onMouseOver={() => setWebNavOpen(true)}
                onMouseLeave={() => setWebNavOpen(false)}
              >
                {link.heading}
                {isDarkDownArrow ? (
                  <Image src={ChevronDownBlack} alt="chevron-down" height={20} width={20} />
                ) : (
                  <Image src={ChevronDownWhite} alt="chevron-down" height={20} width={20} />
                )}
                {isWebNavOpen && (
                  <nav className={classes.dropdownNav}>
                    <div className={classes.dropdown}>
                      <div className={classes.dropdownLinks}>
                        {link.dropdown?.subLinks?.map((subLink, index) =>
                          subLink.external ? (
                            <a
                              key={index}
                              href={subLink.url}
                              className={clsx(classes.subLink)}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {subLink.title}
                            </a>
                          ) : (
                            <Link
                              key={index}
                              href={subLink.url}
                              className={clsx(classes.subLink)}
                              onClick={e => {
                                setWebNavOpen(false)
                              }}
                            >
                              {subLink.title}
                            </Link>
                          ),
                        )}
                      </div>
                    </div>
                  </nav>
                )}
              </div>
            ) : link.external ? (
              <a
                key={index}
                href={link.url}
                className={clsx(classes.link, customLinkClassName)}
                target="_blank"
                rel="noreferrer"
              >
                {link.heading}
              </a>
            ) : (
              <Link key={index} href={link?.url || ''} className={clsx(classes.link, customLinkClassName)}>
                {link.heading}
              </Link>
            ),
          )}
        </div>
        <div className={classes.actions}>
          <Link href={HYBRID_APP} target="_blank">
            <Button variant={signInBtnVariant} text="Sign in" style={signInBtnCustomCss}/>
          </Link>
          <div
            className={clsx(classes.hamburger, {[classes.active]: isMobileNavOpen})}
            onClick={() => setMobileNavOpen(!isMobileNavOpen)}
          >
            <div className={clsx(classes.line, classes.topLine, customLineClassName)}></div>
            <div className={clsx(classes.line, classes.middleLine, customLineClassName)}></div>
            <div className={clsx(classes.line, classes.bottomLine, customLineClassName)}></div>
          </div>
        </div>
      </nav>

      <nav className={clsx(classes.mobileNavbar, {[classes.open]: isMobileNavOpen})}>
        <div className={clsx(classes.mobileLinks)}>
          {navbarLinks.map((link, index) =>
            link.dropdown ? (
              <div key={index} className={clsx(classes.mobileDropdownGroup)}>
                <div className={classes.mobileLink}>
                  {link.heading}
                  <Image src={ChevronDownBlack} alt="chevron-down" height={20} width={20} />
                </div>
                <nav className={classes.mobileDropdownNav}>
                  <div className={classes.mobileDropdown}>
                    <div className={classes.mobileDropdownLinks}>
                      {link.dropdown?.subLinks?.map((subLink, index) =>
                        subLink.external ? (
                          <a
                            key={index}
                            href={subLink.url}
                            className={clsx(classes.subLink)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {subLink.title}
                          </a>
                        ) : (
                          <Link
                            key={index}
                            href={subLink.url}
                            className={clsx(classes.subLink)}
                            onClick={() => setMobileNavOpen(false)}
                          >
                            {subLink.title}
                          </Link>
                        ),
                      )}
                    </div>
                  </div>
                </nav>
              </div>
            ) : link.external ? (
              <a
                key={index}
                href={link.url}
                className={clsx(classes.mobileLink)}
                target="_blank"
                rel="noreferrer"
              >
                {link.heading}
              </a>
            ) : (
              <Link
                key={index}
                href={link?.url || ''}
                className={clsx(classes.mobileLink)}
                onClick={() => setMobileNavOpen(false)}
              >
                {link.heading}
              </Link>
            ),
          )}
        </div>
      </nav>
    </>
  )
}
